/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PeriodoRendicontazioneDTO } from '../model/models';
import { RendicontazioneEsercenteDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DownloadFileRendicontazioneEsercenteRequestParams {
    idRendicontazione: string;
    controfirmata?: boolean;
}

export interface DownloadNotaDebitoRendicontazioneEsercenteRequestParams {
    idRendicontazione: string;
}

export interface GetRendicontazioneEsercenteRequestParams {
    idPeriodo: string;
    idPraticaEsercente: string;
}

export interface ListPeriodiRendicontazioneEsercenteRequestParams {
    idTipoPratica: string;
}

export interface SubmitRendicontazioneEsercenteRequestParams {
    idPeriodo: string;
    idPraticaEsercente: string;
    nota?: Blob;
}


export interface EsercenteRendicontazioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Scarica il file nota firmata / controfirmata caricato (self-service).
     * ?controfirmata&#x3D;true per la controfirmata. Owner-check → 404 cross-esercente; file non valorizzato → 404.
     * @endpoint get /api/v1/esercente/rendicontazioni/{id_rendicontazione}/file
* @param requestParameters
     */
    downloadFileRendicontazioneEsercente(requestParameters: DownloadFileRendicontazioneEsercenteRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Scarica il PDF nota di debito di una propria rendicontazione (self-service).
     * PDF generato on-the-fly. Owner-check: rendicontazione di altro esercente → 404.
     * @endpoint get /api/v1/esercente/rendicontazioni/{id_rendicontazione}/nota-debito
* @param requestParameters
     */
    downloadNotaDebitoRendicontazioneEsercente(requestParameters: DownloadNotaDebitoRendicontazioneEsercenteRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Rendicontazione di un periodo per una propria domanda (compute on-read).
     * Compute idempotente se DA_SOTTOMETTERE. Owner-check via il profilo del caller: una domanda di un altro esercente → 404 privacy-preserving.
     * @endpoint get /api/v1/esercente/rendicontazioni/periodi/{id_periodo}/pratiche/{id_pratica_esercente}
* @param requestParameters
     */
    getRendicontazioneEsercente(requestParameters: GetRendicontazioneEsercenteRequestParams, extraHttpRequestParams?: any): Observable<RendicontazioneEsercenteDTO>;

    /**
     * Periodi di rendicontazione di un bando (self-service).
     * Self-scoped: solo i bandi a cui il caller ha una propria domanda; bando senza stake → 404 privacy-preserving.
     * @endpoint get /api/v1/esercente/rendicontazioni/tipi-pratica/{id_tipo_pratica}/periodi
* @param requestParameters
     */
    listPeriodiRendicontazioneEsercente(requestParameters: ListPeriodiRendicontazioneEsercenteRequestParams, extraHttpRequestParams?: any): Observable<Array<PeriodoRendicontazioneDTO>>;

    /**
     * Sottomissione della nota di debito firmata (self-service).
     * Multipart: part \&#39;nota\&#39; (file obbligatorio → 422 se assente). Upload S3 + transizione {DA_SOTTOMETTERE, RIFIUTATA} → SOTTOMESSA atomici. Periodo non ABILITATO → 422.
     * @endpoint post /api/v1/esercente/rendicontazioni/periodi/{id_periodo}/pratiche/{id_pratica_esercente}/submit
* @param requestParameters
     */
    submitRendicontazioneEsercente(requestParameters: SubmitRendicontazioneEsercenteRequestParams, extraHttpRequestParams?: any): Observable<RendicontazioneEsercenteDTO>;

}
